export enum CircleActionEnum {
  condividi,
  segnala,
  preferiti
}
